import { useMemo, useEffect, RefObject, useState } from 'react';
import { ActionCreator, bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { Action } from 'deox';

export const useAction = <T extends ActionCreator<Action<string>>>(action: T): T => {
  const dispatch = useDispatch();
  return useMemo(() => bindActionCreators(action, dispatch), [action, dispatch]);
};

export const useOnClickOutside = (
  ref: RefObject<HTMLDivElement>,
  handler: (event: MouseEvent | TouchEvent) => void,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target as Node | null)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export const useScrolledToBottom = (ref: RefObject<HTMLDivElement>) => {
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  useEffect(() => {
    const domElement = ref.current;

    const handleScroll = () => {
      if (domElement) {
        if (domElement.offsetHeight + domElement.scrollTop + 100 >= domElement.scrollHeight) {
          if (!scrolledToBottom) {
            setScrolledToBottom(true);
          }
        } else if (scrolledToBottom) {
          setScrolledToBottom(false);
        }
      }
    };

    domElement?.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => domElement?.removeEventListener('scroll', handleScroll);
  });

  return scrolledToBottom;
};
